Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "About2695120311",
  {"root":"About2695120311--root","header":"About2695120311--header","faded":"About2695120311--faded"},
  "",
  3,
  "About2695120311"
);

